<template>
  <footer class="footer">
    <div class="container footer-contrainer">
      <div class="row">
        <div class=" col-sm-4 col-md-4 col-12 col">
          <ul class="navbar-nav menu-list">
            <li class="footer-item" v-for="(item, index) in items" :key=index>
              <router-link class="nav-link" v-bind:to=item.path>
                  {{ item.title }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-sm-8 col-md-8 col-12 col corp-info">
            <ul class="navbar-nav menu-list">
              <li><h5 class="col_white_amrc">東栄運輸株式会社</h5></li>
              <li><p>本社 〒339-0011 埼玉県さいたま市岩槻区長宮77 T:048-799-1211（代表）</p></li>
              <li><p>観光バス部 〒174-0051 東京都板橋区小豆沢2-3-11 T:03-3965-0556（代表）</p></li>
            </ul>
        </div>
      </div>
      <p class="copyright">© 2020 TOEI TRANSPORTATION Inc.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      items: [
        { title: 'TOP', path: '/' },
        { title: 'BUS | 観光バス部門', path: '/bus' },
        { title: 'CARGO | 貨物部門', path: '/cargo' },
        { title: 'CONSTRUCTION | 工事部門', path: '/construction' },
        { title: 'SAFETY | 安全への取り組み', path: '/safety' },
        { title: 'CORPORATION | 企業情報', path: '/corporation' },
        { title: 'RECRUIT | 採用情報', path: '/recruit' }
      ]
    }
  }
}
</script>

<style scoped>
.footer-contrainer {
  max-width: 90%;
}
.footer-item a {
  color: #FFFFFF;
}
.copyright {
  height: auto;
  line-height: 1;
  margin-top: 13px;
  text-align: center;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
}
.col_white_amrc {
  color: #FFFFFF;
  font: bold 18px/14px Source Han Sans JP;
  padding-top:40px;
  margin-bottom:20px;
}
footer {
  width:100%;
  background-color:#263238;
  min-height:250px;
  padding:10px 0px 25px 0px;
}
footer p {
  font-size:16px;
  font: normal 16px/12px Source Han Sans JP;
  color: #FFFFFF;
  line-height: normal;
  padding-bottom:0px;
  margin-bottom:8px;
}
.corp-info {
  display: flex;
  align-items: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue